const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		
		// ===================================
		//	GET REGISTERED USERS
		// ===================================
		case "GET_REGISTRATION_IN_PROCESS":
			return{
				...getBasicStateGet(state),
				inProcess: 1
			}

		case "GET_REGISTRATION_HAS_ERROR":
			return{
				...state,
				inProcess: 0,
				errorGet: action.error
			}

		case "GET_REGISTRATION_SUCCESS":
			return{
				...state,
				registered: action.data.data,
				inProcess: 0
			}

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc.
 * @param object state
 */

function getBasicStateGet(state) {
	const { errorGet, successGet, ...newState } = state;
	return newState;
}




// WEBPACK FOOTER //
// ./src/store/reducers/registered.js